import React from 'react';

let faqFR = ({onMenuToggle}) => {
	return <div>
		<h2>D&eacute;couvrir Enjoy!</h2>
		<div className="faq-warning">
			<p>Nous mettons fin &agrave; Premium Club et &agrave; Bizz Club le 30/11/2019.<br/> Vous pouvez <a
				href="http://www.proximus.be/support/fr/id_sfaqr_club_exchange/particuliers/support/myproximus-et-facturation/premium-club/points-premium-club/echanger-vos-points-premium-club-et-consulter-le-solde.html">&eacute;changer
				vos points Premium Club</a> ou, si vous &ecirc;tes un client professionnel, <a
				href="http://www.proximus.be/support/fr/id_sfaqs_club_exchange/independants-et-petites-entreprises/support/myproximus-et-facturation/bizz-club/points-bizz-club/echanger-vos-points-bizz-club-et-consulter-le-solde.html">&eacute;changer
				vos points Bizz Club</a> jusqu'au 30/11/2019.</p>
		</div>
		<p>Premium Club et Bizz Club sont remplac&eacute;s par Enjoy! En tant que client Proximus, vous trouvez dans
			MyProximus deux types d'avantages exclusifs : Enjoy! experiences et Enjoy! deals.</p>
		<h2 id="howto">Consulter Enjoy! </h2>
		<p>Pour consulter les ristournes et concours Enjoy!, vous devez &ecirc;tre <a
			href="https://www.proximus.be/support/fr/id_sfaqs_mypx_register/independants-et-petites-entreprises/support/myproximus-et-facturation/myproximus/application-myproximus/comment-s-inscrire-a-myproximus.html">inscrit </a>et<a
			href="https://www.proximus.be/support/fr/id_sfaqr_mypx_login/particuliers/support/myproximus-et-facturation/myproximus/site-web-myproximus/comment-vous-connecter-a-myproximus.html"> connect&eacute;</a> &agrave; MyProximus. <a
			href="https://www.proximus.be/support/fr/id_sfaqs_mypx_no_access/independants-et-petites-entreprises/support/myproximus-et-facturation/myproximus/site-web-myproximus/pas-d-acces-a-myproximus.html">Vous
			ne parvenez pas &agrave; vous inscrire ou &agrave; vous connecter ?</a></p>
		<p>Vous pouvez alors consulter les offres Enjoy! via MyProximus (via l'app et via le web) :</p>
		<ol>
			<li>Via l'app : appuyez dans l'app MyProximus sur Plus puis sur Mes avantages.<br/> Via le site web :
				cliquez sur le bouton ci-dessous et connectez-vous.<br/> <a
					href="https://www.proximus.be/myproximus/en/Personal/services/My-Rewards__.html">Consultez
					Enjoy!</a></li>
			<li>Cliquez sur Enjoy! experiences ou sur Enjoy! deals :
				<ul>
					<li>Enjoy! experiences : participez &agrave; un ou plusieurs concours. Les gagnants sont avertis par
						e-mail.
					</li>
					<li>Enjoy! deals : profitez de r&eacute;ductions int&eacute;ressantes. V&eacute;rifiez bien la date
						d'expiration de votre r&eacute;duction ou avantage. Vous ne pouvez l'utiliser qu'une seule fois.
					</li>
				</ul>
			</li>
		</ol>
		<h2>Vous ne parvenez pas &agrave; l&rsquo;utiliser&nbsp;ou vous rencontrez un probl&egrave;me ?</h2>
		<p>Analysez votre situation. Nous sommes &agrave; votre disposition pour vous aider.</p>
		<div className="panel-group" id="accordion">
			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
						Vous ne retrouvez pas Enjoy! ou vous n'y avez pas acc&egrave;s ?
					</a>
				</div>
				<div id="collapseOne" className="panel-collapse collapse in">
					<p>V&eacute;rifiez si vous &ecirc;tes dans la situation suivante :</p>
					<ul>
						<li>Si votre nom ne figure pas en haut de l'&eacute;cran dans MyProximus, vous n'&ecirc;tes pas
							correctement <a
								href="https://www.proximus.be/support/fr/id_sfaqr_mypx_login/particuliers/support/myproximus-et-facturation/myproximus/site-web-myproximus/comment-vous-connecter-a-myproximus.html">connect&eacute;</a> ou <a
								href="https://www.proximus.be/support/fr/id_sfaqs_mypx_register/independants-et-petites-entreprises/support/myproximus-et-facturation/myproximus/application-myproximus/comment-s-inscrire-a-myproximus.html">inscrit</a>.
						</li>
						<li>Si votre abonnement mobile est pay&eacute; par votre employeur, vous ne pouvez pas
							participer &agrave; Enjoy!
						</li>
						<li>Vous devez avoir plus de 18 ans.</li>
					</ul>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">
						Vous ne parvenez plus &agrave; consulter un Enjoy! deal ou une Enjoy! Experience
						sp&eacute;cifique ?
					</a>
				</div>
				<div id="collapseTwo" className="panel-collapse collapse in">
					<p>Les Enjoy! deals et les Enjoy! experiences sont limit&eacute;s dans le temps et en nombre. Le
						tout est donc de rester aux aguets ! Cependant, il y a r&eacute;guli&egrave;rement de nouvelles
						r&eacute;ductions et exp&eacute;riences. Consultez donc fr&eacute;quemment Enjoy!, comme
						expliqu&eacute; <a href="#howto">ci-dessus</a>.</p>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion"
					   href="#collapseThree">
						Vous ne retrouvez plus le code, le voucher ou le lien de votre Enjoy! deal ?
					</a>
				</div>
				<div id="collapseThree" className="panel-collapse collapse in">
					<p>Vous pouvez retrouver cette information jusqu'&agrave; sa date d'expiration via MyProximus.
						Suivez les &eacute;tapes suivantes :</p>
					<ol>
						<li>Consultez Enjoy! comme expliqu&eacute; <a href="#howto">ci-dessus</a>.</li>
						<li>Cliquez sur votre Enjoy! deal. Vous y trouverez le code, le voucher ou le lien.</li>
					</ol>
					<p>Vous ne pouvez utiliser votre r&eacute;duction ou avantage qu'une seule fois jusqu'&agrave; la
						date d'expiration et ne pouvez pas les combiner.</p>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion"
					   href="#collapseFour">
						Votre code pour un Enjoy! deal ne fonctionne pas ?
					</a>
				</div>
				<div id="collapseFour" className="panel-collapse collapse in">
					<p>Une fois que le code a &eacute;t&eacute; utilis&eacute; ou que sa date d'expiration est
						d&eacute;pass&eacute;e, il ne fonctionne plus. Toutefois, si votre code ne fonctionne pas avant
						la date d'expiration, prenez <a href="http://www.proximus.be/contact">contact</a> par chat ou
						par e-mail. Gardez votre <a
							href="https://www.proximus.be/support/fr/id_sfaqr_mypx_credentials/particuliers/support/myproximus-et-facturation/myproximus/site-web-myproximus/numero-de-client-code-d-activation-et-date.html">num&eacute;ro
							de client</a> sous la main.</p>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion"
					   href="#collapseFive">
						Vous n'avez pas re&ccedil;u les tickets gagnants de votre Enjoy! experience ?
					</a>
				</div>
				<div id="collapseFive" className="panel-collapse collapse in">
					<p>Prenez <a href="http://www.proximus.be/contact">contact</a> par chat ou par e-mail. Gardez
						votre <a
							href="https://www.proximus.be/support/fr/id_sfaqr_mypx_credentials/particuliers/support/myproximus-et-facturation/myproximus/site-web-myproximus/numero-de-client-code-d-activation-et-date.html">num&eacute;ro
							de client</a> sous la main. </p>
				</div>
			</div>

		</div>
	</div>
};

export default faqFR;